import NotificationVignette from './NotificationVignette';

export default NotificationVignette;
